import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["getItemAttributes", "getItemDisabled", "getItemIconLeft", "getItemIconRight", "getItemKey", "getItemLabel", "getItemOnClick", "getItemRef", "getItemSubTitle", "getItemTagName"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { Chips } from "../Chips/Chips";
var defaultGetItemKey = function defaultGetItemKey(item) {
  return item.key;
};
var defaultGetItemLabel = function defaultGetItemLabel(item) {
  return item.label;
};
var defaultGetItemIconLeft = function defaultGetItemIconLeft(item) {
  return item.iconLeft;
};
var defaultGetItemIconRight = function defaultGetItemIconRight(item) {
  return item.iconRight;
};
var defaultGetItemOnClick = function defaultGetItemOnClick(item) {
  return item.onClick;
};
var defaultGetItemRef = function defaultGetItemRef(item) {
  return item.ref;
};
var defaultGetItemAttributes = function defaultGetItemAttributes(item) {
  return item.attributes;
};
var defaultGetItemDisabled = function defaultGetItemDisabled(item) {
  return item.disabled;
};
var defaultGetItemSubTitle = function defaultGetItemSubTitle(item) {
  return item.subTitle;
};
var defaultGetItemTagName = function defaultGetItemTagName(item) {
  return item.tagName;
};
export var composePreparedProps = function composePreparedProps(_ref) {
  var getItemAttributes = _ref.getItemAttributes,
    getItemDisabled = _ref.getItemDisabled,
    getItemIconLeft = _ref.getItemIconLeft,
    getItemIconRight = _ref.getItemIconRight,
    getItemKey = _ref.getItemKey,
    getItemLabel = _ref.getItemLabel,
    getItemOnClick = _ref.getItemOnClick,
    getItemRef = _ref.getItemRef,
    getItemSubTitle = _ref.getItemSubTitle,
    getItemTagName = _ref.getItemTagName,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread(_objectSpread({}, props), {}, {
    getters: {
      getItemKey: getItemKey || defaultGetItemKey,
      getItemLabel: getItemLabel || defaultGetItemLabel,
      getItemIconLeft: getItemIconLeft || defaultGetItemIconLeft,
      getItemIconRight: getItemIconRight || defaultGetItemIconRight,
      getItemOnClick: getItemOnClick || defaultGetItemOnClick,
      getItemRef: getItemRef || defaultGetItemRef,
      getItemAttributes: getItemAttributes || defaultGetItemAttributes,
      getItemDisabled: getItemDisabled || defaultGetItemDisabled,
      getItemSubTitle: getItemSubTitle || defaultGetItemSubTitle,
      getItemTagName: getItemTagName || defaultGetItemTagName
    }
  });
};
export var getItemActive = function getItemActive(getItemKey, item, values) {
  if (!values) {
    return false;
  }
  return !!values.find(function (el) {
    return getItemKey(item) === getItemKey(el);
  });
};
export var createRenderFunction = function createRenderFunction(params) {
  return function (item, isActive) {
    var _params$getItemAttrib;
    return /*#__PURE__*/React.createElement(Chips, _extends({}, (_params$getItemAttrib = params.getItemAttributes(item)) !== null && _params$getItemAttrib !== void 0 ? _params$getItemAttrib : {}, {
      active: isActive,
      color: params.color,
      disabled: params.disabled || params.getItemDisabled(item),
      iconLeft: params.getItemIconLeft(item),
      iconRight: params.getItemIconRight(item),
      invert: params.invert,
      key: params.getItemKey(item),
      label: params.getItemLabel(item),
      onClick: params.onItemClick(item),
      ref: params.getItemRef(item),
      subTitle: params.getItemSubTitle(item),
      tagName: params.getItemTagName(item)
    }));
  };
};
export var isNullbaleRender = function isNullbaleRender(children) {
  var _React$Children$map;
  return !((_React$Children$map = React.Children.map(children, function (child) {
    return /*#__PURE__*/React.isValidElement(child) && (child && typeof child.type === 'function' ? child.type(child.props) : child.type);
  })) !== null && _React$Children$map !== void 0 && _React$Children$map.length);
};